export default __webpack_public_path__ + "static/media/CFDI2.a43771d5.png";